import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
export const TEXT_NOTE_LIST = "textNoteList";

export function fetchTextNotesIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
          TEXT_NOTE_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findTextNotes();
        },
        force
      )
    );
  };
}
